import ControlledSelectElement from "../../components/elements/ControlledSelectElement2";
import InputComponent from "../../components/elements/InputComponent";
import TextareaComponent from "../../components/elements/TextareaComponent";
import RadioCheckbox from "../../components/elements/RadioCheckbox";
import ButtonComponent from "../../components/elements/ButtonComponent";
import InputPlusButton from "../../components/elements/InputPlusButton";
import { IFormDataU } from "../../pages/user-stepper/UserStepper";
import { motion } from "framer-motion";
import customZ from "../../utils/setZodCustomMessages";
import { requiredMessage } from "../../utils/validationCustomMessages";
import { zodResolver } from "@hookform/resolvers/zod";
import z from "../../utils/setZodCustomMessages";
import { childVariants } from "../../animation/RoutesAnimations";
import {
  notEmptyField,
  postalCodeSchema,
  landlinenumberSchema,
} from "../../utils/customSchemas";
import { useForm, SubmitHandler } from "react-hook-form";
import { CustomAxiosRequestConfig, axiosPrivate } from "../../api/axios";
import { useEffect, useState } from "react";
import Lottie from "react-lottie";
import animationData from "../../../src/jsons/LoadingBg.json";
import { useQuery, useMutation } from "@tanstack/react-query";
import {
  CORE_CITY,
  CORE_CITY_NO_ID,
  CORE_PROVINCE,
  USER_FILL_RESIDENTIAL_INFO,
  USER_GET_RESIDENTIAL_INFO,
  USER_RESIDENTIAL_INFO_UPDATE,
} from "../../api/apiClient";
import React from "react";

const step2Schema = customZ.object({
  postal_code: postalCodeSchema,
  tell_number: landlinenumberSchema,
  addresss: notEmptyField,
  type: notEmptyField,
  city: z.string().refine((value) => value !== "undefined", {
    message: requiredMessage,
  }),
  id: z.string().refine((value) => value !== "undefined", {
    message: requiredMessage,
  }),
});

export interface provinceType {
  id: number;
  name: string;
}

export interface cityType {
  city: number;
  name: string;
}

const TypeofOwner = [
  { label: "مالک", value: "o" },
  { label: "مستاجر", value: "t" },
];

function UserFormStep2({ formNo, setFormNo }: any) {
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm<IFormDataU>({
    resolver: (data, context, options) => {
      return zodResolver(step2Schema)(data, context, options);
    },
  });
  const access_token = localStorage.getItem("access_token");
  const [residentialInfo, setResidentialInfo] = useState<any>(null);
  const [city, setCity] = useState([
    { name: "", id: 1, city: 1, prefix_number: "021" },
  ]);
  const [province, setProvince] = useState([{ name: "", id: 1 }]);
  const [provinceGetId, setProvinceGetId] = useState<any>(undefined);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [cityAPI, setCityAPI] = useState(false);
  const [prefixNum, setPrefixNum] = useState<any>(undefined);
  const [ciName, setCIName] = useState<any>(undefined);
  const [receivedValue, setReceivedValue] = useState("");
  const [isLoadingContents, setIsLoadingContents] = useState<boolean>(false);
  const [canEdit, setCanEdit] = useState<boolean>(false);

  const handleValueReceived = (value: any) => {
    setReceivedValue(value);
  };

  useEffect(() => {
    if (receivedValue) {
      setValue("addresss", receivedValue);
    }
  }, [receivedValue]);

  useEffect(() => {
    if (
      city[
        city.findIndex((obj: any) => obj["id"] === Number(getValues("city")))
      ] !== undefined
    ) {
      setPrefixNum(
        city[
          city.findIndex((obj: any) => obj["id"] === Number(getValues("city")))
        ]["prefix_number"]
      );
    } else {
      setPrefixNum(null);
    }
  }, [getValues("city"), getValues("id")]);

  const transformData = (data: IFormDataU) => {
    return {
      ...data,
      address: data.addresss, // Transform addresss to address
    };
  };

  const updateFormValue: SubmitHandler<IFormDataU> = async (
    data: IFormDataU
  ) => {
    const transformedData = transformData(data);

    try {
      const response = await axiosPrivate.put(
        USER_RESIDENTIAL_INFO_UPDATE,
        transformedData,
        {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );

      if (response?.status >= 200 && response?.status < 300) {
        setFormNo(formNo + 1);
        setIsSubmiting(false);
      } else {
        console.error(
          "ERROR in acceptRules:",
          response.data || response.statusText
        );
      }
    } catch (error) {
      setIsSubmiting(false);
      console.error("An unexpected error occurred:", error);
    }
  };

  const onSubmit: SubmitHandler<IFormDataU> = async (data: IFormDataU) => {
    setIsSubmiting(true);

    if (!residentialInfo || residentialInfo.length === 0) {
      const formattedData = {
        ...data,
        address: data.addresss, // Transform addresss to address
      };

      try {
        const response = await axiosPrivate.post(
          USER_FILL_RESIDENTIAL_INFO,
          formattedData,
          {
            headers: {
              // prettier-ignore
              "accept": "application/json",
              // prettier-ignore
              "Authorization": `Bearer ${access_token}`,
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          }
        );

        if (response?.status >= 200 && response?.status < 300) {
          setFormNo(formNo + 1);
          setIsSubmiting(false);
        } else {
          console.error(
            "ERROR in acceptRules:",
            response.data || response.statusText
          );
        }
      } catch (error) {
        setIsSubmiting(false);
        console.error("An unexpected error occurred:", error);
      }
    }
    if (residentialInfo && !canEdit) {
      setFormNo(formNo + 1);
    }
    if (residentialInfo && canEdit) {
      updateFormValue(data);
    }
  };

  const findProvince = async (id: any) => {
    if (residentialInfo) {
      try {
        const response = await axiosPrivate.get(
          CORE_CITY_NO_ID,

          {
            headers: {
              // prettier-ignore
              "accept": "application/json",
              // prettier-ignore
              "Authorization": `Bearer ${access_token}`,
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          }
        );

        let res = response.data.data.result;

        setProvinceGetId(
          res[res.findIndex((obj: any) => obj["id"] === id)]["province_id"]
        );
      } catch (error) {}
    }
  };

  const getCity = async (id: number) => {
    setCityAPI(true);
    try {
      const response = await axiosPrivate.get(
        CORE_CITY(id),

        {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
          globalErrorHandler: false,
        } as CustomAxiosRequestConfig
      );
      var res = response.data.data.result;

      for (let i = 0; i < res.length; i++) {
        res[i]["city"] = res[i]["id"];
      }

      setCity((prev) => res);
      setCityAPI(false);
      if (response?.status >= 200 && response?.status < 300) {
        setIsSubmiting(false);
        setCityAPI(false);
      } else {
      }
    } catch (error) {
      setCityAPI(false);
    }
  };

  const getProvince = async () => {
    try {
      const response = await axiosPrivate.get(
        CORE_PROVINCE,

        {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );

      setProvince(response.data.data.result);

      if (response?.status >= 200 && response?.status < 300) {
        setIsSubmiting(false);
      } else {
      }
    } catch (error) {}
  };

  const getResidentialInfo = () =>
    axiosPrivate
      .get(USER_GET_RESIDENTIAL_INFO, {
        headers: {
          // prettier-ignore
          "accept": "application/json",
          // prettier-ignore
          "Authorization": `Bearer ${access_token}`,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      })
      .then((res) => setResidentialInfo(res?.data?.data));

  const getResidentialIngoQuery = useQuery({
    queryKey: ["getResidentialQuery"],
    queryFn: () => getResidentialInfo(),
  });

  useEffect(() => {
    // getResidentialInfo();
    getProvince();
  }, []);

  useEffect(() => {
    getCity(provinceGetId ? provinceGetId : 133);
  }, []);

  useEffect(() => {
    getCity(watch("id"));
  }, [getValues("id"), watch("id")]);

  useEffect(() => {
    setValue(
      "addresss",
      receivedValue ? receivedValue : residentialInfo?.address
    );
    findProvince(residentialInfo?.city);
    setValue("type", residentialInfo?.type);
    setValue("city", String(residentialInfo?.city));
    setValue("tell_number", residentialInfo?.tell_number);
    setValue("postal_code", residentialInfo?.postal_code);
    setValue("id", String(residentialInfo ? 133 : "undefined"));
  }, [setValue, residentialInfo]);

  useEffect(() => {
    const textAreaValue = getValues("addresss");

    if (receivedValue && textAreaValue === receivedValue) {
      setValue("addresss", receivedValue);
    }
  }, [receivedValue, getValues]);

  async function findProvinceName(id: any) {
    try {
      const response = await axiosPrivate.get(
        CORE_CITY_NO_ID,

        {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );
      let res = response.data.data.result;
      setValue(
        "id",
        String(
          res[res.findIndex((obj: any) => obj["id"] === id)]["province_id"]
        )
      );
      var idp = res[res.findIndex((obj: any) => obj["id"] === id)]["name"];
      var r =
        province[
          province.findIndex(
            (o: any) =>
              o["id"] ===
              res[res.findIndex((obj: any) => obj["id"] === id)]["province_id"]
          )
        ]["name"];

      setCIName(idp);
    } catch (error) {}
  }

  localStorage.setItem("selected city", watch("city"));
  localStorage.setItem("selected prov", watch("id"));

  useEffect(() => {
    if (residentialInfo) {
      findProvinceName(residentialInfo.city);
    }
  }, [residentialInfo]);

  function cityAdder(data: any) {
    for (let i = 0; i < data.length; i++) {
      data[i]["city"] = data[i]["id"];
    }
    return data;
  }

  const getCityTest = (id: number) =>
    axiosPrivate
      .get(
        CORE_CITY(id),

        {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
          globalErrorHandler: false,
        } as CustomAxiosRequestConfig
      )

      .then((res) => cityAdder(res.data.data.result));

  const cityMutate = useMutation({
    mutationFn: (id: any) => getCityTest(id),
    onSuccess(data, variables, context) {
      setCity(data);
    },
  });

  useEffect(() => {
    watch("id") !== undefined &&
      watch("id") !== "undefined" &&
      cityMutate.mutate(watch("id"));
  }, []);

  //
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  const watchedAddresss = watch("addresss");
  const watchedCity = watch("city");
  const watchedPostalCode = watch("postal_code");
  const watchedTellNumber = watch("tell_number");
  const watchedType = watch("type");
  const watchedProvince = watch("id");
  useEffect(() => {
    if (
      watchedAddresss !== residentialInfo?.address ||
      parseInt(watchedCity) !== residentialInfo?.city ||
      watchedPostalCode !== residentialInfo?.postal_code ||
      watchedTellNumber !== residentialInfo?.tell_number ||
      watchedType !== residentialInfo?.type
    ) {
      setCanEdit(true);
    } else {
      setCanEdit(false);
    }
  }, [
    watchedProvince,
    watchedAddresss,
    watchedCity,
    watchedPostalCode,
    watchedTellNumber,
    watchedType,
    residentialInfo,
  ]);

  return (
    <>
      {isLoadingContents ? (
        <>
          <div className="flex  gap-8 basis-3/4 rounded-md md:ml-8 ml-2 shadow-md">
            <div className=" full-screen">
              <Lottie options={defaultOptions} height={100} width={100} />
            </div>
          </div>
        </>
      ) : (
        <motion.form
          variants={childVariants}
          initial="initial"
          animate="final"
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-1 gap-12 rounded-md shadow-md item-center justify-center"
        >
          <div className="lg:flex flex-col gap-6  rounded-md shadow-md ">
            <div className="flex ">
              <div className="ml-3 w-[50%]">
                <ControlledSelectElement
                  APIgetValue={residentialInfo?.province_name}
                  // disabled={residentialInfo}
                  label=" استان"
                  options={province}
                  isRequired
                  getOptionLabel={(item) => item?.name}
                  control={control}
                  name="id"
                  errors={errors?.id}
                  showNonOption
                  editable={true}
                  defaultSelectValue={"انتخاب کنید"}
                  mode="multiSelect"
                />
              </div>
              <div className="w-[50%]">
                <ControlledSelectElement
                  APIgetValue={residentialInfo ? ciName : undefined}
                  disabled={cityAPI || watch("id") === "undefined"}
                  label="شهر"
                  isLoading={cityMutate.isPending}
                  options={city}
                  isRequired
                  getOptionLabel={(item) => item?.name}
                  control={control}
                  name="city"
                  errors={errors?.city}
                  showNonOption
                  defaultSelectValue={"انتخاب کنید"}
                  mode="multiSelect"
                />
              </div>
            </div>

            <div className="relative">
              <InputComponent
                defaultValue={residentialInfo?.tell_number}
                direction="ltr"
                size="regular"
                isRequired
                type="tel"
                label=" شماره ثابت "
                name="tell_number"
                control={control}
                errors={errors?.tell_number}
                svgIcon={
                  <img
                    src="/icons/phone-outline.svg"
                    alt="phone icon"
                    width={16}
                  />
                }
                maxLength={8}
                fixNumber="px-[80px]"
              />
              <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-900 pl-3 pr-6 text-sm border-r-2 border-gray-300 p-1">
                {prefixNum === null ? "021" : prefixNum}
              </span>
            </div>

            <div className="">
              <div className="">
                <label className=" text-gray-900 text-Body-OneLine/14/Regular">
                  کد پستی
                </label>

                <span className="text-red-500 mr-[4px]">*</span>
              </div>
              <div className="">
                <InputPlusButton
                  onValueReceived={handleValueReceived}
                  APIgetValue={residentialInfo?.postal_code}
                  editable={true}
                  direction="ltr"
                  type="tel"
                  name="postal_code"
                  // btnText="استعلام"
                  inputIcon={
                    <img
                      src="/icons/mail-box-outline.svg"
                      alt="phone icon"
                      width={16}
                    />
                  }
                  control={control}
                  errors={errors?.postal_code}
                  maxLength={10}
                />
              </div>
            </div>
            <TextareaComponent
              APIgetValue={receivedValue ? receivedValue : ""}
              latestReceivedValue={receivedValue}
              editable={true}
              helperText="در صورت صحیح نبودن آدرس استعلام شده، آدرس را ویرایش نمایید."
              onChange={(value) => handleValueReceived(value)} // Handle user input
              value={
                receivedValue
                  ? receivedValue
                  : residentialInfo?.address
                  ? residentialInfo?.address
                  : undefined
              }
              dynamicRows={3}
              control={control}
              label="آدرس منزل"
              name="addresss"
              errors={errors?.addresss}
              isRequired
            />
            <RadioCheckbox
              editable
              defaultValue={residentialInfo?.type ? residentialInfo?.type : ""}
              label="نوع مالکیت"
              name="type"
              isRequired
              options={Object.values(TypeofOwner)}
              control={control}
              errors={errors?.type}
            />
            <div className="pb-8 flex item-center justify-center sticky bottom-0 bg-white right-0">
              <ButtonComponent
                className="mt-8 w-[120px] h-10"
                variant="outlined"
                onClick={() => setFormNo(formNo - 1)}
              >
                بازگشت
              </ButtonComponent>
              <ButtonComponent
                type="submit"
                className="mt-8 w-[120px] h-10 mr-[8px]"
                variant="filled"
                isClicked={isSubmiting}
                disabled={isSubmiting}
              >
                ادامه
              </ButtonComponent>
            </div>
          </div>
        </motion.form>
      )}
    </>
  );
}
export default React.memo(UserFormStep2);
